import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dce2b9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-gradient weight-500 d-inline-flex" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-20 weight-500" }, "В ролях:", -1))
const _hoisted_4 = { class: "trailer px-20 py-10 mt-20" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Трейлер", -1))
const _hoisted_6 = {
  key: 3,
  class: "backstage my-40 px-20"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-20" }, "Бекстейдж", -1))

import router from '@/router'
import BackLine from '@/components/Lines/BackLine.vue'
import CircleButton from '@/components/Buttons/CircleButton.vue'
import CreateAccount2 from '@/components/Register/CreateAccount2.vue'
import ProjectSeriesSlider from '@/components/Sliders/ProjectSeriesSlider.vue'

import BorderText from '@/components/BorderText.vue'
import BackStagePlayer from '@/components/Players/BackStagePlayer.vue'
import { computed, onMounted, ref, unref } from 'vue'
import { useRoute } from 'vue-router'
import { getPlaylistById, IPlaylist } from '@/api'
import PreviewTrailerPlayer from '@/components/Players/PreviewTrailerPlayer.vue'
import { useAuthStore } from '@/stores/auth'
import NewProjectIdea from '@/components/NewProjectIdea.vue'
import ProjectVotes from '@/components/ProjectVotes.vue'
import ProjectSeriesSliderLoader from '@/components/Loaders/ProjectSeriesSliderLoader.vue'
import TextLoader from '@/components/Loaders/TextLoader.vue'
import OneVideoLoader from '@/components/Loaders/OneVideoLoader.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectView',
  setup(__props) {


const authStore = useAuthStore()
const isAuth = computed(() => authStore.isAuth)

const route = useRoute()
const playList = ref<IPlaylist | null>(null)

const loadPlaylistDataAsync = async (playListId) => {
  if (!playListId) {
    return undefined
  }
  try {
    const { data } = await getPlaylistById(playListId)
    playList.value = data
    const description = playList.value?.description.toString().replace(/\\n/g, '<br>')
    try {
      playList.value.description = JSON.parse(description)
    } catch (e) {
      console.log('JSON parse error')
    }
  } catch (error) {
    console.error(error, 'error')
  }
}

loadPlaylistDataAsync(route.params.id)


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackLine, null, {
      default: _withCtx(() => [
        _createVNode(_component_router_link, { to: { name: 'home' } }, {
          default: _withCtx(() => [
            _createVNode(CircleButton, {
              name: "chevron-left-gradient",
              bg: "empty",
              iconWidth: 21,
              iconHeight: 16,
              "view-box": "0 0 21 16"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (!playList.value?.playlist_media)
          ? (_openBlock(), _createBlock(ProjectSeriesSliderLoader, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (playList.value?.playlist_media)
      ? (_openBlock(), _createBlock(ProjectSeriesSlider, {
          key: 0,
          playlistMedia: playList.value?.playlist_media
        }, null, 8, ["playlistMedia"]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (!playList.value?.playlist_media)
          ? (_openBlock(), _createBlock(BorderText, {
              key: 0,
              class: "pa-10"
            }, {
              default: _withCtx(() => [
                _createVNode(TextLoader, { height: "15" })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (playList.value?.description)
      ? (_openBlock(), _createBlock(BorderText, {
          key: 1,
          class: "pa-10"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_1, _toDisplayString(playList.value?.description?.title), 1),
            _createElementVNode("h6", {
              class: "fs-14",
              innerHTML: playList.value?.description?.description
            }, null, 8, _hoisted_2)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(BorderText, { class: "pa-10" }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (!playList.value?.description)
              ? (_openBlock(), _createBlock(TextLoader, {
                  key: 0,
                  height: "20"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(playList.value?.description?.roles, (role) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "role pa-10",
            key: role
          }, _toDisplayString(role), 1))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (!playList.value?.description)
            ? (_openBlock(), _createBlock(OneVideoLoader, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (playList.value?.description)
        ? (_openBlock(), _createBlock(PreviewTrailerPlayer, {
            key: 0,
            trailerId: playList.value?.description.trailer
          }, null, 8, ["trailerId"]))
        : _createCommentVNode("", true)
    ]),
    false
      ? (_openBlock(), _createBlock(BorderText, {
          key: 2,
          class: "pa-10"
        }, {
          default: _withCtx(() => [
            (playList.value?.description)
              ? (_openBlock(), _createBlock(NewProjectIdea, {
                  key: 0,
                  title: playList.value?.description?.title
                }, null, 8, ["title"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(ProjectVotes),
    (playList.value?.description?.backst_id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (!playList.value?.description)
                ? (_openBlock(), _createBlock(OneVideoLoader, { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (playList.value?.description)
            ? (_openBlock(), _createBlock(BackStagePlayer, {
                key: 0,
                trailerId: playList.value?.description.backst_id,
                backstPict: playList.value?.description.backst_pict
              }, null, 8, ["trailerId", "backstPict"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!isAuth.value)
      ? (_openBlock(), _createBlock(CreateAccount2, { key: 4 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})